"use strict";

var _interopRequireWildcard = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.number.to-fixed.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.function.name.js");

var _market = require("@/model/exchange/market.js");

var _index = require("@/model/exchange/index");

var _order = require("@/model/contractExchange/order.js");

var _InputNumber = _interopRequireDefault(require("@/components/common/InputNumber"));

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _index2 = require("@/utils/index.js");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _message = require("@/components/dialog/message.js");

var Account = _interopRequireWildcard(require("@/model/user/account"));

var _settings = require("@/model/settings");

var _keymap = require("@/assets/js/keymap.js");

var _digital = require("@/assets/js/digital");

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//FIXME
var _default2 = {
  mixins: [_commonMixin.default],
  props: {
    marketList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    swap_symbol_id: {
      type: [String, Number],
      default: function _default() {
        return 100901;
      }
    },
    assetsInfo: {
      type: Object,
      default: function _default() {
        return {
          remain: {
            all_u_valuation: {
              usdt: "--"
            },
            list: []
          }
        };
      }
    },
    from_symbol: {
      type: [String, Number]
    },
    to_symbol: {
      type: [String, Number]
    },
    from_item_id: {
      type: [String, Number]
    },
    to_item_id: {
      type: [String, Number]
    }
  },
  components: {
    NoData: _NoData.default,
    InputNumber: _InputNumber.default
  },
  data: function data() {
    return {
      closePositionTypeMaps: _keymap.closePositionTypeMaps,
      parseTime: _index2.parseTime,
      ws: null,
      tableData: [],
      confirmMessage: "是否确认平仓此订单？",
      tableDataComputed: [],
      orderLoading: true,
      dialogVisible: false,
      appendMoneydialog: false,
      setProfitPricedialog: false,
      row_swap_symbol_id: this.swap_symbol_id,
      beforeBailNumber: "",
      afterBailNumber: "--",
      inputProfitPrice: "",
      inputLossPrice: "",
      price_precision: "",
      contract_plan_num: 0,
      contract_position_num: 0,
      contract_multiple_num: "",
      beforeLiquidationPrice: "",
      plan_order_id: "",
      afterLiquidationPrice: "--",
      rowData: {},
      hidenCancelChecked: false,
      checked: false,
      layout: "total, prev, pager, next",
      symbolId: "",
      position_order_id: "",
      bail_number: "",
      contractMultipleNum: {},
      pageInfo: {
        pageCount: 1,
        pageCurrent: 1,
        pageSize: 6,
        pageTotal: 6
      },
      apiAssetsInfo: {},
      tabList: [{
        value: "1",
        label: "持仓"
      }, {
        value: "2",
        label: "当前委托"
      }, // {
      //   value: "3",
      //   label: "历史委托",
      // },
      {
        value: "4",
        label: "成交记录"
      }],
      currIndex: "1",
      symbolList: {},
      coinInfoMap: {},
      triggerSideMap: {
        1: "大于触发价",
        2: "小于触发价"
      },
      tradeMap: {
        1: "市价",
        2: "限价"
      },
      sideMap: {
        1: "买涨",
        2: "买跌"
      },
      statusMap: {
        0: "未成交",
        1: "待成交",
        2: "完全成交",
        3: "已撤销",
        4: "失败"
      }
    };
  },
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$Account$getUse, userInfo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getCoinInfoMap();

            case 2:
              _context.next = 4;
              return _this.getTradePairList();

            case 4:
              _this.getOrderNumber();

              _this.getAssets();

              _context.next = 8;
              return Account.getUserInfo();

            case 8:
              _yield$Account$getUse = _context.sent;
              userInfo = _yield$Account$getUse.userInfo;

              if (userInfo) {
                _this.initData(_this.checked);

                _this.startTimer();
              }

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(timer);
  },
  mounted: function mounted() {},
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language",
    systemCurrency: "user/currency"
  })), {}, {
    marketInfoShow: function marketInfoShow() {
      var _this2 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this2.swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    rowMarketInfoShow: function rowMarketInfoShow() {
      var _this3 = this;

      var marketInfo = {
        last: "",
        currency: {
          cny: ""
        }
      };
      this.marketList.forEach(function (ele) {
        if (ele.symbol_id == _this3.row_swap_symbol_id) {
          marketInfo = ele;
        }
      });
      return marketInfo;
    },
    // 现有U资产
    assetsInfoShow: function assetsInfoShow() {
      var _this4 = this;

      var tempObj = "0";

      if (JSON.stringify(this.assetsInfo) != "{}" && this.assetsInfo.remain.list.length > 0) {
        this.assetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else if (JSON.stringify(this.apiAssetsInfo) != "{}" && this.apiAssetsInfo.remain.list.length > 0) {
        this.apiAssetsInfo.remain.list.forEach(function (ele) {
          if (ele.item_id == _this4.to_item_id) {
            tempObj = ele.over;
          }
        });
      } else {
        tempObj = "--";
      }

      return tempObj;
    },
    afterLiquidationPriceShow: function afterLiquidationPriceShow() {
      // 强平价 = 开仓价 - (1 做多 | -1做空)) ×(保证金 × (1 − 强平⻛险率) - 平仓手续费-开仓手续费)/持仓数量
      var tempValue = "";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.bail_number != "") {
        tempValue = this.rowData.open_price - tempSide * (this.afterBailNumberShow * (1 - this.symbolList[this.swap_symbol_id].liquidation_risk_rate / 10000) - this.rowData.close_position_fee - this.rowData.open_position_fee) / this.rowData.open_interest;

        if (this.rowData.open_side == 1) {
          //做多 做多的时候小数位用全进
          tempValue = (Math.ceil(tempValue * Math.pow(10, this.price_precision)) / Math.pow(10, this.price_precision)).toFixed(this.price_precision);
        } else {
          // 做空的时候用截断
          tempValue = tempValue.toString().substring(0, tempValue.toString().indexOf(".") + this.price_precision + 1);
        }
      } else {
        tempValue = this.afterLiquidationPrice;
      }

      if (Number(tempValue) < 0) {
        tempValue = "0";
      }

      return tempValue;
    },
    afterBailNumberShow: function afterBailNumberShow() {
      return (Number(this.afterBailNumber) + Number(this.bail_number)).toFixed(2);
    },
    // 平仓盈亏 = (inputProfitPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedProfit: function expectedProfit() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (Number(this.inputProfitPrice) - Number(temp_open_price)) * tempSide * Number(this.rowData.open_interest) - Number(this.rowData.close_position_fee);
        tempValue = (0, _digital.floorNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        }
      } // inputProfitPrice


      return tempValue;
    },
    expectedProfitPercent: function expectedProfitPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputProfitPrice != "" && Number(this.inputProfitPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = ((this.inputProfitPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number * 100;
        tempValue = (0, _digital.floorNumber)(tempValue, 2);

        if (Number(tempValue) <= 0) {
          tempValue = "--";
        } else {
          tempValue = "+" + tempValue;
        }
      } // inputProfitPrice


      return tempValue;
    },
    // 平仓盈亏 = (inputLossPrice-开仓价) × (1 做多 | -1做空)) × 持仓数量  - 平仓手续费
    expectedLoss: function expectedLoss() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = (this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee;
        tempValue = (0, _digital.ceilNumber)(tempValue, 2); // tempValue = Math.ceil(tempValue * 100) / 100;

        if (Number(tempValue) < this.rowData.bail_number * -1) {
          tempValue = this.rowData.bail_number * -1;
        }

        if (Number(tempValue) > 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    },
    expectedLossPercent: function expectedLossPercent() {
      var tempValue = "--";
      var tempSide = this.rowData.open_side == 1 ? 1 : -1;

      if (this.inputLossPrice != "" && Number(this.inputLossPrice) != 0) {
        var temp_open_price = "";

        if (this.currIndex == 1) {
          temp_open_price = this.rowData.open_price;
        } else {
          temp_open_price = this.rowData.trigger_price;
        }

        tempValue = ((this.inputLossPrice - temp_open_price) * tempSide * this.rowData.open_interest - this.rowData.close_position_fee) / this.rowData.bail_number * 100;
        tempValue = (0, _digital.ceilNumber)(tempValue, 2);

        if (Number(tempValue) < -100) {
          tempValue = -100;
        }

        if (Number(tempValue) > 0) {
          tempValue = "--";
        }
      } // inputLossPrice


      return tempValue;
    }
  }),
  methods: {
    routeSplicing: _routeSplicing.default,
    onOK: function onOK() {
      if (this.dialogType == 1) {
        this.onClosePosition();
      } else if (this.dialogType == 2) {
        this.onCancelOrder();
      } else if (this.dialogType == 3) {
        this.onRevokeAllOrder();
      } else if (this.dialogType == 4) {
        this.onRevokePlan();
      }
    },
    goToRecharge: function goToRecharge() {
      window.open(this.routeSplicing(this.language, "ucenter/assets/recharge/usdt"));
    },
    onClearAll: function onClearAll() {
      this.inputProfitPrice = "";
    },
    onClearAllV2: function onClearAllV2() {
      this.inputLossPrice = "";
    },
    setProfitPricedialogClose: function setProfitPricedialogClose() {
      this.inputLossPrice = "";
      this.inputProfitPrice = "";
      this.setProfitPricedialog = false;
    },
    appendMoneydialogClose: function appendMoneydialogClose() {
      this.bail_number = "";
      this.appendMoneydialog = false;
    },
    onClickAll: function onClickAll() {
      this.bail_number = this.assetsInfoShow;
    },
    reset: function reset(type) {
      this.orderLoading = true;
      this.currIndex = type.toString();
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
      this.getOrderNumber();
    },
    getAssets: function getAssets() {
      var _this5 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this5.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "all"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  _this5.apiAssetsInfo = data;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onProfitPriceEdit: function onProfitPriceEdit(row) {
      this.rowData = row;
      this.row_swap_symbol_id = row.symbol_id;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    onLossPriceEdit: function onLossPriceEdit(row) {
      this.rowData = row;

      if (row.stop_profit_price != "--") {
        this.inputProfitPrice = row.stop_profit_price;
      } else {
        this.inputProfitPrice = "";
      }

      if (row.stop_loss_price != "--") {
        this.inputLossPrice = row.stop_loss_price;
      } else {
        this.inputLossPrice = "";
      }

      this.setProfitPricedialog = true;
    },
    getCoinInfoMap: function getCoinInfoMap() {
      var _this6 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$apiGetStaticTa, status, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(13);

              case 2:
                _yield$apiGetStaticTa = _context3.sent;
                status = _yield$apiGetStaticTa.status;
                data = _yield$apiGetStaticTa.data;

                if (status == 200) {
                  _this6.coinInfoMap = data;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getTradePairList: function getTradePairList() {
      var _this7 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _yield$apiGetStaticTa2, status, data;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _settings.apiGetStaticTableInfo)(49);

              case 2:
                _yield$apiGetStaticTa2 = _context4.sent;
                status = _yield$apiGetStaticTa2.status;
                data = _yield$apiGetStaticTa2.data;

                if (status == 200) {
                  _this7.symbolList = data;
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onSymbolChange: function onSymbolChange(item) {
      this.$emit("on-symbol-change", item);
    },
    onSymbolClick: function onSymbolClick(row) {
      var tempName = "";

      if (row.from_symbol_name) {
        tempName = row.from_symbol_name.toLowerCase() + "_" + "usdt";
      } else {
        for (var key in this.coinInfoMap) {
          if (key == row.open_item_id) {
            tempName = this.coinInfoMap[key].item_name.toLowerCase() + "_" + "usdt";
          }
        }
      }

      var params = {
        symbol_id: row.symbol_id,
        name: tempName,
        change_item_id: row.open_item_id,
        base_item_id: row.settlement_item_id
      };
      this.$emit("on-symbol-change", params);
    },
    onOpenConfirm: function onOpenConfirm(type, id) {
      this.dialogType = type;

      if (type == 1) {
        this.position_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认平仓此订单？");
      } else if (type == 2) {
        this.confirmMessage = this.translateTitle("是否确认全部平仓？");
      } else if (type == 3) {
        this.confirmMessage = this.translateTitle("是否确认全部撤销？");
      } else if (type == 4) {
        this.plan_order_id = id;
        this.confirmMessage = this.translateTitle("是否确认撤销此委托单？");
      }

      this.dialogVisible = true;
    },
    onOpenAppendMoney: function onOpenAppendMoney(row) {
      this.position_order_id = row.position_order_id;
      this.beforeBailNumber = row.bail_number;
      this.afterBailNumber = row.bail_number;
      this.beforeLiquidationPrice = row.liquidation_price;
      this.afterLiquidationPrice = row.liquidation_price;
      this.rowData = row;

      for (var key in this.symbolList) {
        if (key == row.symbol_id) {
          this.price_precision = this.symbolList[key].price_precision;
        }
      }

      this.appendMoneydialog = true;
    },
    onClosePosition: function onClosePosition() {
      var _this8 = this;

      var params = {
        position_order_id: this.position_order_id
      };
      (0, _order.apiClosePosition)(params).then(function (res) {
        if (res.status == 200) {
          _this8.dialogVisible = false;
          (0, _message.showMessage)({
            message: _this8.translateTitle("平仓成功"),
            type: "success" // duration:10000000,

          });

          _this8.initData(_this8.checked);
        }
      });
    },
    onAppendMoney: function onAppendMoney() {
      var _this9 = this;

      if (Number(this.bail_number) == 0) {
        (0, _message.showMessage)({
          message: this.translateTitle("请输入追加金额"),
          type: "error"
        });
        return;
      }

      var params = {
        position_order_id: this.position_order_id,
        bail_number: this.bail_number
      };
      (0, _order.apiAppendInterest)(params).then(function (res) {
        if (res.status == 200) {
          (0, _message.showMessage)({
            message: _this9.translateTitle("追加成功"),
            type: "success"
          });
          _this9.appendMoneydialog = false;

          _this9.initData(_this9.checked);
        }
      });
    },
    startTimer: function startTimer() {
      var _this10 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var timer;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                timer = setTimeout(function () {
                  _this10.initData(_this10.checked);

                  _this10.getOrderNumber();

                  _this10.getMultipleNum();

                  _this10.startTimer();
                }, 3000);

                _this10.$once("hook:beforeDestroy", function () {
                  clearTimeout(timer);
                });

                _this10.$once("hook:destroyed", function () {
                  clearTimeout(timer);
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onCancelOrder: function onCancelOrder() {
      var _this11 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$apiAllClosePos, status, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _order.apiAllClosePosition)();

              case 2:
                _yield$apiAllClosePos = _context6.sent;
                status = _yield$apiAllClosePos.status;
                data = _yield$apiAllClosePos.data;

                if (status == 200) {
                  _this11.dialogVisible = false;
                  (0, _message.showMessage)({
                    message: _this11.translateTitle("平仓成功"),
                    type: "success"
                  });

                  _this11.initData(_this11.checked);
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onRevokeAllOrder: function onRevokeAllOrder() {
      var _this12 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$apiRevokeAllPl, status, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return (0, _order.apiRevokeAllPlan)();

              case 2:
                _yield$apiRevokeAllPl = _context7.sent;
                status = _yield$apiRevokeAllPl.status;
                data = _yield$apiRevokeAllPl.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this12.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this12.dialogVisible = false;

                  _this12.initData(_this12.checked);
                }

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onRevokePlan: function onRevokePlan() {
      var _this13 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var req, _yield$apiRevokePlan, status, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                req = {
                  plan_order_id: _this13.plan_order_id
                };
                _context8.next = 3;
                return (0, _order.apiRevokePlan)(req);

              case 3:
                _yield$apiRevokePlan = _context8.sent;
                status = _yield$apiRevokePlan.status;
                data = _yield$apiRevokePlan.data;

                if (status == 200) {
                  (0, _message.showMessage)({
                    message: _this13.translateTitle("撤销成功"),
                    type: "success"
                  });
                  _this13.dialogVisible = false;

                  _this13.initData(_this13.checked);
                }

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onSetPositionProfitLoss: function onSetPositionProfitLoss() {
      var _this14 = this;

      // if (this.inputLossPrice == "" && this.inputProfitPrice == "") {
      //   showMessage({ message: "请输入止盈价或止损价", type: "error" });
      //   return;
      // }
      if (this.currIndex == 1) {
        var params = {
          position_order_id: this.rowData.position_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: this.inputProfitPrice,
          stop_loss_price: this.inputLossPrice
        };
        (0, _order.apiSetPositionProfitLoss)(params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this14.translateTitle("设置成功"),
              type: "success"
            });

            _this14.setProfitPricedialogClose();

            _this14.initData(_this14.checked);
          }
        });
      } else {
        var _params = {
          plan_order_id: this.rowData.plan_order_id,
          market_price: this.rowMarketInfoShow.last,
          stop_profit_price: this.inputProfitPrice,
          stop_loss_price: this.inputLossPrice
        };
        (0, _order.apiSetPlanProfitLoss)(_params).then(function (res) {
          if (res.status == 200) {
            (0, _message.showMessage)({
              message: _this14.translateTitle("设置成功"),
              type: "success"
            });

            _this14.setProfitPricedialogClose();

            _this14.initData(_this14.checked);
          }
        });
      }
    },
    onAreaChange: function onAreaChange(item) {
      this.orderLoading = true;
      this.tableData = [];
      this.currIndex = item.value;
      this.pageInfo.pageCurrent = 1;
      this.initData(this.checked);
    },
    getMultipleNum: function getMultipleNum() {
      var _this15 = this;

      var params = {
        symbol_id: ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this15.contract_multiple_num = JSON.stringify(res.data.contract_multiple_num);
          localStorage.setItem("stock-multiple-num", _this15.contract_multiple_num);
        }
      });
    },
    getOrderNumber: function getOrderNumber() {
      var _this16 = this;

      var params = {
        symbol_id: this.checked ? this.swap_symbol_id : ""
      };
      (0, _order.apiGetOrderStatistic)(params).then(function (res) {
        if (res.status == 200) {
          _this16.contract_position_num = res.data.contract_position_info.total_num;
          _this16.contract_plan_num = res.data.contract_plan_info.total_num;
        }
      });
    },
    initData: function initData() {
      var _arguments = arguments,
          _this17 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var checked, _yield$Account$getUse2, userInfo, tempStatus, temp_symbol_id, temp_is_hide, req, _req, temp_order_status, _req2, _req3;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                checked = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;

                if (_this17.swap_symbol_id) {
                  _context9.next = 4;
                  break;
                }

                _this17.orderLoading = false;
                return _context9.abrupt("return");

              case 4:
                _context9.next = 6;
                return Account.getUserInfo();

              case 6:
                _yield$Account$getUse2 = _context9.sent;
                userInfo = _yield$Account$getUse2.userInfo;

                if (userInfo) {
                  _context9.next = 11;
                  break;
                }

                _this17.orderLoading = false;
                return _context9.abrupt("return");

              case 11:
                tempStatus = _this17.currIndex;

                if (_this17.currIndex == 3) {
                  tempStatus = "";
                }

                temp_symbol_id = _this17.swap_symbol_id;
                temp_is_hide = 2;

                if (checked) {
                  temp_symbol_id = _this17.swap_symbol_id;
                  temp_is_hide = 1;
                } else {
                  temp_symbol_id = "";
                  temp_is_hide = 2;
                }

                if (!(_this17.currIndex == 1)) {
                  _context9.next = 21;
                  break;
                }

                req = {
                  symbol_id: temp_symbol_id,
                  position_status: 1,
                  page: _this17.pageInfo.pageCurrent,
                  page_size: _this17.pageInfo.pageSize // is_hide: temp_is_hide,

                };
                return _context9.abrupt("return", (0, _order.apiGetOpenPositionList)(req).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      // 存各个币种杠杆倍数
                      _this17.contractMultipleNum[ele.symbol_id] = {
                        open_leverage: ele.open_leverage
                      }; // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量

                      // 持仓盈亏 = (市价-开仓价) × (1 做多 | -1做空)) × 持仓数量
                      _this17.marketList.forEach(function (item) {
                        if (item.symbol_id == ele.symbol_id) {
                          ele.last_price = item.last;
                        }
                      });

                      var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

                      // 未实现盈亏
                      ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
                      ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);

                      for (var key in _this17.coinInfoMap) {
                        if (key == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[key].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.list;
                    _this17.pageInfo = res.data.pageInfo;
                  } else {
                    _this17.tableData = [];
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 21:
                if (!(_this17.currIndex == 2)) {
                  _context9.next = 26;
                  break;
                }

                _req = {
                  symbol_id: temp_symbol_id,
                  order_status: 1,
                  is_hide: 2,
                  page: _this17.pageInfo.pageCurrent,
                  page_size: _this17.pageInfo.pageSize
                };
                return _context9.abrupt("return", (0, _order.apiGetPlanOrderList)(_req).then(function (res) {
                  if (res.status == 200) {
                    var _loop = function _loop(key) {
                      res.data.list.forEach(function (ele) {
                        _this17.marketList.forEach(function (item) {
                          if (item.symbol_id == ele.symbol_id) {
                            ele.last_price = item.last;
                          }
                        });

                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      });
                    };

                    for (var key in _this17.exchangeCoinMap) {
                      _loop(key);
                    }

                    _this17.tableData = res.data.list;
                    _this17.pageInfo = res.data.pageInfo;
                  } else {
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 26:
                if (!(_this17.currIndex == 3)) {
                  _context9.next = 33;
                  break;
                }

                temp_order_status = "2,3,4";

                if (_this17.hidenCancelChecked) {
                  temp_order_status = "2,4";
                } else {
                  temp_order_status = "2,3,4";
                }

                _req2 = {
                  symbol_id: temp_symbol_id,
                  order_status: temp_order_status,
                  is_hide: 2,
                  page: _this17.pageInfo.pageCurrent,
                  page_size: _this17.pageInfo.pageSize
                };
                return _context9.abrupt("return", (0, _order.apiGetPlanOrderList)(_req2).then(function (res) {
                  if (res.status == 200) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this17.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key in _this17.coinInfoMap) {
                        if (_key == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[_key].item_name.toUpperCase();
                        }

                        if (_key == ele.settlement_item_id) {
                          ele.to_symbol_name = _this17.coinInfoMap[_key].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.list;
                    _this17.pageInfo = res.data.pageInfo;
                  } else {
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 33:
                if (!(_this17.currIndex == 4)) {
                  _context9.next = 36;
                  break;
                }

                _req3 = {
                  symbol_id: temp_symbol_id,
                  position_status: 2,
                  page: _this17.pageInfo.pageCurrent,
                  page_size: _this17.pageInfo.pageSize
                };
                return _context9.abrupt("return", (0, _order.apiGetOpenPositionList)(_req3).then(function (res) {
                  if (res.status == 200 && res.data.list.length > 0) {
                    res.data.list.forEach(function (ele) {
                      for (var key in _this17.exchangeCoinMap) {
                        if (ele.symbol_id == key) {
                          ele.symbol_name = _this17.exchangeCoinMap[key].name.toUpperCase();
                        }
                      }

                      for (var _key2 in _this17.coinInfoMap) {
                        if (_key2 == ele.open_item_id) {
                          ele.from_symbol_name = _this17.coinInfoMap[_key2].item_name.toUpperCase();
                        }
                      }
                    });
                    _this17.tableData = res.data.list;
                    _this17.pageInfo = res.data.pageInfo;
                  } else {
                    _this17.tableData = [];
                    _this17.orderLoading = false;
                  }

                  _this17.orderLoading = false;
                }));

              case 36:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    onCurrentPageChange: function onCurrentPageChange() {
      this.initData(this.checked);
    }
  },
  watch: {
    swap_symbol_id: {
      handler: function handler(newVal, oldVal) {
        if (oldVal == undefined) {
          return;
        }

        if (newVal != oldVal) {
          this.symbolId = newVal;
          this.orderLoading = true;
          this.pageInfo.pageCurrent = 1;
          this.initData(this.checked);
        }
      }
    },
    hidenCancelChecked: function hidenCancelChecked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    checked: function checked() {
      this.initData(this.checked);
      this.getOrderNumber();
    },
    marketList: function marketList() {
      var _this18 = this;

      if (this.currIndex == 1 || this.currIndex == 2) {
        this.tableData.forEach(function (ele) {
          _this18.marketList.forEach(function (item) {
            if (item.symbol_id == ele.symbol_id) {
              ele.last_price = item.last;
            }
          });

          var tempSide = ele.open_side == 1 ? 1 : -1; // 未实现盈亏

          ele.position_profit_loss = (ele.last_price - ele.open_price) * tempSide * ele.open_interest;
          ele.position_profit_loss_procent = ((ele.last_price - ele.open_price) * tempSide * ele.open_interest / ele.bail_number * 100).toFixed(2);
        });
      }
    }
  }
};
exports.default = _default2;